import React from 'react';
import PropTypes from 'prop-types';
import { ListSubheader } from '@material-ui/core';
import {
  Button,
  List,
  ListItem,
  makeStyles,
  Text,
} from '@knockrentals/knock-shared-web';
import { AddCircleSvgIcon } from '../../../../Components/Icons';
import EligibleQualification from './EligibleQualification';
import { getIsAddRowDisabled, getPersonsOptions } from './utils';

const useStyles = makeStyles({
  subHeader: {
    lineHeight: '16px',
    marginBottom: '8px',
  },
  subHeaderText: {
    display: 'inline-block',
    marginRight: '16px',
    width: '200px',
  },
});

export const MAX_OCCUPANTS = 8;

const AffordableIncomeEligibility = ({
  clearValidationErrorMessage,
  deleteEligibleQualification,
  incomeEligibility,
  setIncomeEligibility,
  updateEligibleQualification,
}) => {
  const classes = useStyles();

  const handleAddRowOnClick = () => {
    setIncomeEligibility((prev) => {
      return [...prev, {}];
    });
  };

  const isAddRowDisabled = getIsAddRowDisabled(
    incomeEligibility,
    MAX_OCCUPANTS
  );
  const personsOptions = getPersonsOptions(incomeEligibility, MAX_OCCUPANTS);

  return (
    <div className="affordable-list">
      <List
        dense
        disablePadding
        subheader={
          <ListSubheader
            className={classes.subHeader}
            component="div"
            disableGutters
            disableSticky
          >
            <Text
              className={classes.subHeaderText}
              component="span"
              variant="caption"
            >
              Occupants
            </Text>
            <Text
              className={classes.subHeaderText}
              component="span"
              variant="caption"
            >
              Maximum Income
            </Text>
          </ListSubheader>
        }
      >
        {incomeEligibility.map((eligibleQualification, index) => {
          const {
            errorMessages = {},
            maximum_income,
            occupants,
          } = eligibleQualification;
          return (
            <EligibleQualification
              clearValidationErrorMessage={clearValidationErrorMessage(
                maximum_income,
                occupants
              )}
              deleteEligibleQualification={deleteEligibleQualification}
              errorMessages={errorMessages}
              key={`${eligibleQualification.occupants}-${index}`}
              maximumIncome={maximum_income}
              occupants={occupants}
              personOptions={personsOptions}
              updateEligibleQualification={updateEligibleQualification(
                maximum_income,
                occupants
              )}
            />
          );
        })}

        <ListItem dense disableGutters>
          <Button
            disabled={isAddRowDisabled}
            onClick={handleAddRowOnClick}
            startIcon={<AddCircleSvgIcon />}
            variant="outlined"
          >
            Add row
          </Button>
        </ListItem>
      </List>
    </div>
  );
};

AffordableIncomeEligibility.propTypes = {
  clearValidationErrorMessage: PropTypes.func,
  deleteEligibleQualification: PropTypes.func,
  incomeEligibility: PropTypes.arrayOf(
    PropTypes.shape({
      maximum_income: PropTypes.string,
      occupants: PropTypes.string,
    })
  ),
  setIncomeEligibility: PropTypes.func,
  updateEligibleQualification: PropTypes.func,
};

export default AffordableIncomeEligibility;
